import MainImg from "./MainImg";
export default MainImg;
